export function translateToEnglish(word: string) {
  const symbols = 'აბცდეფგჰიჯკლმნოპქრსტუვწხყზთჟღშჩძჭ';
  let char: string, index: number;
  const text = [];
  for (let i = 0; i < word.length; i++) {
    char = word.substr(i, 1);
    if ((index = symbols.indexOf(char)) >= 0 && index === 26) {
      text.push('t');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 27) {
      text.push('j');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 28) {
      text.push('g');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 29) {
      text.push('sh');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 30) {
      text.push('ch');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 31) {
      text.push('dz');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 32) {
      text.push('tch');
    } else if ((index = symbols.indexOf(char)) >= 0 && index === 22) {
      text.push('ts');
    } else if ((index = symbols.indexOf(char)) >= 0) {
      text.push(String.fromCharCode(index + 65));
    } else {
      text.push(char);
    }
  }
  return text.join('').replace(/[^a-z\d\s\-]+/gi, '').toLowerCase();
}


export function convertToBase64(file): Promise<any> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
